module.exports = __webpack_public_path__ + "static/media/hero-image-desktop@0.5x.d6309d60.jpg";